module.exports = __webpack_public_path__ + "img/hongbao.3868613a.png";